import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { Table } from "@zillow/constellation";
import PropTypes from "prop-types";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockTable = ({
  attrs,
  index
}) => {
  const {
    head,
    body,
    ...otherProps
  } = attrs;
  const sectionMap = {
    head: Table.Header,
    body: Table.Body
  };
  const cellMap = {
    head: Table.HeaderCell,
    body: Table.Cell
  };
  function TSection({
    name,
    ...props
  }) {
    const TagName = sectionMap[name];
    return /* @__PURE__ */ jsx(TagName, { ...props });
  }
  function TCell({
    name,
    ...props
  }) {
    const TagName = cellMap[name];
    return /* @__PURE__ */ jsx(TagName, { ...props });
  }
  return /* @__PURE__ */ jsx(Table.Responsive, { children: /* @__PURE__ */ createElement(Table, { ...otherProps, key: index }, ["head", "body"].map((name) => /* @__PURE__ */ jsx(TSection, { name, children: attrs[name] && attrs[name].map(({
    cells
  }, rowIndex) => (
    // eslint-disable-next-line zillow/react/no-array-index-key
    /* @__PURE__ */ jsx(Table.Row, { name, children: cells.map(({
      content
    }, columnIndex) => (
      // eslint-disable-next-line zillow/react/no-array-index-key
      /* @__PURE__ */ jsx(TCell, { name, children: makeContentInteractive(content) }, columnIndex)
    )) }, rowIndex)
  )) }, name))) });
};
BlockTable.propTypes = {
  attrs: PropTypes.shape({
    appearance: PropTypes.string,
    size: PropTypes.string
  }),
  index: PropTypes.number
};
export {
  BlockTable as default
};
